import { render, staticRenderFns } from "./Formas-juridicas.vue?vue&type=template&id=159285a2"
import script from "./Formas-juridicas.vue?vue&type=script&lang=js"
export * from "./Formas-juridicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports